export default "__VITE_ASSET__aCnkIng$__"